module.exports = __webpack_public_path__ + "img/kailihe.b82b6d8b.png";